import { render, staticRenderFns } from "./ProductTypePlanManager.vue?vue&type=template&id=39ae14ee&"
import script from "./ProductTypePlanManager.vue?vue&type=script&lang=js&"
export * from "./ProductTypePlanManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports